<span>
    <svg class="icon icon-{{icon()}}" [attr.viewBox]="viewBox()">
        <use xmlns:xlink="http://www.w3.org/1999/xlink" [attr.xlink:href]="xlink_href()"></use>
    </svg>
</span>
